import {memo} from 'react';

import styles from './LogoWall.module.scss';
import {StrapiLogoWall} from './LogoWall.types';
import {LogoWallItem} from './LogoWallItem/LogoWallItem';
import {Marquee} from './Marquee/Marquee';

export type LogoWallProps = {
  logoWall: StrapiLogoWall;
  onLogoClick?: (href: string, index: number) => void;
};

const ROWS_WALL_COUNT = 3;

export const LogoWall = memo(({logoWall, onLogoClick}: LogoWallProps) => {
  const logoWalls = logoWall.LogoWallMarque.slice(0, ROWS_WALL_COUNT);

  return (
    <div className={styles.logoWall}>
      {logoWalls.map((marque, parentId) => (
        <Marquee key={marque.id} marqueeSpeed={marque.MarqueSpeed}>
          {marque.LogoWallLogo.map((marqueItem, id) => (
            <LogoWallItem
              key={parentId + id}
              index={id}
              isTargetBlank={marqueItem.isTargetBlank}
              href={marqueItem.href}
              logoSrc={marqueItem.Logo.url}
              onLogoClick={onLogoClick}
            />
          ))}
        </Marquee>
      ))}
    </div>
  );
});
